// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"nlvdXIW","size-sm":"D4IqcPY","sizeSm":"D4IqcPY","mobile":"IQMgSkl"};